import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import IconSearch from '../../assets/images/IconSearch.png';
import Service from "./../../utils/apiOpen";
import Calendar from '../../assets/images/Calendar.png';
import { Form, Row, Col, Table, Button, Typography, DatePicker, TreeSelect, message, Skeleton } from 'antd';
import dayjs from "dayjs";
import Chart from "react-apexcharts";
import Helper from "./../../utils/helper"
import { createGlobalStyle } from 'styled-components'

const Dashboard = () => {
  const [config, setConfig] = useState({});
  const [summary, setSummary] = useState({});
  const [products, setProducts] = useState([]);
  const [contributors, setContributors] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lineChart, setLineChart] = useState({
    totalViews: []
    ,
    totalOrders: []
  })

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});

  const GlobalStyles = createGlobalStyle`
    .apexcharts-yaxis {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .ant-table-thead .ant-table-cell {
        background-color: #ffffff !important;
    }
    
    .ant-table-tbody .ant-table-row {
        
    }
        
    .ant-table-cell { 
        font-size: 11px !important;
        font-weight: 400 !important
    }
    
    .ant-form-item-control-input-content {
        border-radius: 5px;
        box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1);
    }
    
    .ant-select-selection-placeholder {
        color: #343a40 !important;
    }
    
    th {
        padding: 5px 0px 5px 0px;
        border-bottom: 0.5px solid #D2D2D2;
        font-weight: 400; 
        font-size: 11px; 
        font-family: roboto; 
        color: #343a40;
    }
    
    td {
        font-size: 11px;
        font-weight: 400;
        font-family: roboto;
        padding: 12px 10px 12px 10px;
    }
    `;


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getConfig();
      getSummary();
      getProductsTop();
      getContributorsTop();
      getDashboard();
    }, 100);
    return () => clearTimeout(timeoutId);
  }, [formData]);

  const onFinish = (val) => {
    form
      .validateFields()
      .then(async (values) => {
        setFormData({ ...values });
      })
      .catch((err) => {

      });
  };

  const getDashboard = () => {
    setLoading(true);
    const dataForm = {
      month: formData?.month ? dayjs(formData?.month, "month").format('YYYY-MM') : dayjs().subtract(0, "month").format('YYYY-MM'),
      affProductUid: formData?.affProductUid?.length > 0 ? formData.affProductUid.join(',') : undefined,
    }
    Service.openApiCall('GET', `/v1/affiliate/portal/dashboard/chart`, dataForm)
      .then((res) => {
        setLoading(false);
        if (res.data.success) {
          setLineChart({
            totalViews: res?.data?.data?.totalViews,
            totalOrders: res?.data?.data?.totalOrders
          })
        }
      })
      .catch((err) => {
        setLoading(false);
        if (err?.response) {
          message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
        }
      });
  };

  const getConfig = () => {
    Service.openApiCall('GET', `/v1/affiliate/portal/dashboard/config`)
      .then((res) => {
        if (res.data.success) {
          setConfig(res?.data?.data);
        }
      })
      .catch((err) => {
        if (err?.response) {
          message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
        }
      });
  };

  const getSummary = () => {
    const dataForm = {
      month: formData?.month ? dayjs(formData?.month, "month").format('YYYY-MM') : dayjs().subtract(0, "month").format('YYYY-MM'),
      affProductUid: formData?.affProductUid?.length > 0 ? formData.affProductUid.join(',') : undefined,
    }
    Service.openApiCall('GET', `/v1/affiliate/portal/dashboard/summary`, dataForm)
      .then((res) => {
        if (res.data.success) {
          setSummary(res?.data?.data);
        }
      })
      .catch((err) => {
        if (err?.response) {
          message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
        }
      });
  };

  const getProductsTop = () => {
    const dataForm = {
      month: formData?.month ? dayjs(formData?.month, "month").format('YYYY-MM') : dayjs().subtract(0, "month").format('YYYY-MM')
    }
    Service.openApiCall('GET', `/v1/affiliate/portal/dashboard/product/top`, dataForm)
      .then((res) => {
        if (res.data.success) {
          setProducts(res?.data?.data);
        }
      })
      .catch((err) => {
        if (err?.response) {
          message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
        }
      });
  };

  const getContributorsTop = () => {
    const dataForm = {
      month: formData?.month ? dayjs(formData?.month, "month").format('YYYY-MM') : dayjs().subtract(0, "month").format('YYYY-MM')
    }
    Service.openApiCall('GET', `/v1/affiliate/portal/dashboard/member/top`, dataForm)
      .then((res) => {
        if (res.data.success) {
          setContributors(res?.data?.data);
        }
      })
      .catch((err) => {
        if (err?.response) {
          message.error(err?.response?.data?.error?.statusCode + '|' + err?.response?.data?.message);
        }
      });
  };

  const chartOptions = {
    options: {
      yaxis: {
        // min: 0,
        // max: 23,
        tickAmount: 10,
        labels: {
          style: {
            colors: ['#969696'],
            fontSize: 11,
            fontFamily: 'Roboto',
            fontWeight: 400
          },
          formatter: (value) => {
            return Helper.formatNumber2(value);
          },
          maxWidth: 50,
        },
      },
      xaxis: {
        categories: Array.from({ length: lineChart?.totalOrders?.length }, (_, i) => i + 1),
        labels: {
          style: {
            fontSize: '11px',
            fontFamily: 'Roboto'

          }
        }
      },
      stroke: {
        curve: 'straight',
        width: 1
      },

      legend: {
        show: false
      },
      chart: {
        height: 300,
        toolbar: {
          show: false,
        }
      },
    },
    series: [
      {
        name: "Tổng lượt xem",
        data: lineChart.totalViews.map((item) => +item.value),
        color: '#0B7CE4'
      },
      {
        name: "Tổng lượt mua hàng",
        data: lineChart.totalOrders.map((item) => +item.value),
        color: '#069D27'
      }
    ],

  };

  const dashboardGC = [
    { id: "1", title: "Tổng lượt click", value: summary?.[0]?.totalClicks }, { id: "2", title: "Tổng lượt xem", value: summary?.[0]?.totalViews },
    { id: "3", title: "Tổng số data", value: summary?.[0]?.totalConsults }, { id: "4", title: "Tổng số đơn", value: summary?.[0]?.totalOrders },
    { id: "5", title: "Tổng doanh thu (VND)", value: summary?.[0]?.totalRevenue }, { id: "6", title: "Tổng thu nhập(VND)", value: summary?.[0]?.totalIncome },
  ]

  return (
    <>
      <div className='container-page'>
        <GlobalStyles />
        <Row style={{ display: 'grid', gap: '15px' }}>
          <Row style={{ display: 'flex', justifyContent: 'space-between', padding: 0, marginBottom: 10 }}>
            <Col>
              <Typography.Title level={1}
                style={{
                  fontWeight: 400, fontSize: '16px', fontFamily: '"Roboto", sans-serif',
                  color: '#343a40', marginBottom: 0,
                  display: 'grid', placeItems: 'center', alignItems: 'center', marginTop: 6
                }}
              >
                Dashboard
              </Typography.Title>
            </Col>

            <Form onFinish={onFinish} form={form}>
              <Row gutter={[16, 16]} style={{ display: 'flex', justifyContent: 'end' }}>
                <Col style={{ paddingBottom: '0px' }}>
                  <Form.Item label="" colon={false} name="month" style={{ marginBottom: 0 }}>
                    <DatePicker
                      allowClear={false}
                      placeholder="Chọn tháng"
                      // format={"MM.YYYY"}
                      suffixIcon={<img src={Calendar} width={16} />}
                      format={(value) => `Theo tháng: ${dayjs(value).format("MM.YYYY")}`}
                      style={{ borderRadius: 4, padding: "0px 6px", height: 32 }}
                      defaultValue={dayjs().subtract(0, "month")}
                      picker="month"
                      monthCellRender={(date) => {
                        const month = dayjs(date).format("MM");
                        return <div className="pickerCustom"> Tháng {month}</div>;
                      }}
                    />
                  </Form.Item>
                </Col>

                <Col>
                  <Form.Item name="affProductUid" style={{ marginBottom: 0 }}>
                    <TreeSelect
                      dropdownMatchSelectWidth={false}
                      allowClear
                      multiple
                      showSearch={true}
                      treeCheckable={true}
                      style={{ width: 200 }}
                      maxTagCount={'responsive'}
                      showArrow={true}
                      filterTreeNode={(input, node) => {
                        const normalize = str =>
                          str?.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
                        return normalize(node?.title || '').includes(normalize(input));
                      }}
                      maxTagPlaceholder={(omittedValues) => `+${omittedValues.length} sản phẩm`}
                      placeholder={<span style={{ color: '#343A40' }}>Sản phẩm</span>}
                    >
                      {
                        (config?.products || []).map((item) => (
                          <TreeSelect.TreeNode key={item?.uid} value={item?.uid} title={item?.title} />
                        ))
                      }
                    </TreeSelect>
                  </Form.Item>
                </Col>

                <Col>
                  <Button
                    loading={loading}
                    htmlType="submit"
                    type="primary"
                    icon={<img src={IconSearch} style={{
                      width: '15px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }} />}
                    style={{
                      background: '#0B7CE4',
                      borderColor: '#0B7CE4',
                      display: 'flex',
                      alignItems: 'center',
                      boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)'
                    }}
                  >
                    Tìm kiếm
                  </Button>
                </Col>
              </Row>
            </Form >
          </Row>
          <Row style={{
            display: 'flex',
            justifyContent: 'space-between',
            padding: '15px',
            boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)',
            border: '0.5px solid #D2D2D2',
            borderRadius: '16px',
            backgroundColor: 'white',
            gap: '15px'
          }}>
            {dashboardGC.map((item, index) => (
              <Col key={item.id} style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                gap: '15px',
                justifyContent: 'space-between',
                flex: '1'
              }}>
                <Col style={{
                  width: '100%',
                  display: 'grid',
                  placeItems: 'center',
                  // border: '1px solid'
                }}>
                  <Row style={{
                    marginBottom: '10px',
                    fontSize: '13px',
                    color: '#969696'
                  }}>
                    {item.title}
                  </Row>
                  <Row style={{
                    marginBottom: '0px',
                    color: ' #0B7CE4',
                    fontSize: '24px',
                    fontWeight: '700',
                    display: 'flex',
                    gap: '5px'
                  }}>
                    {
                      loading ?
                        <Skeleton.Input active={true} size="small" style={{ borderRadius: 5 }} /> :
                        <>
                          {item.value}
                          {/* {["Tổng doanh thu", "Tổng thu nhập"].includes(item.title) && (
                            <Col style={{
                              color: '#969696',
                              fontSize: '13px',
                              fontWeight: '400',
                              display: 'flex',
                              justifyContent: 'flex-start'

                            }}>VND</Col>
                          )} */}
                        </>
                    }

                  </Row>
                </Col>
                {index < dashboardGC.length - 1 && <Col style={{
                  width: '1px',
                  height: '100%',
                  backgroundColor: '#D2D2D2',
                  transform: 'rotate(180deg)'
                }} />
                }
              </Col>
            ))}
          </Row>

          {/* Biểu đồ */}
          <Row style={{
            display: 'grid',
            padding: '30px',
            gap: '30px',
            backgroundColor: 'white',
            borderRadius: '16px'
          }}>
            <Row style={{ justifyContent: 'space-between' }}>
              <Col style={{ fontSize: '14px', fontWeight: '700' }}>
                Tổng quan
              </Col>
              <Col style={{ display: 'flex', gap: '32px' }}>
                <Col style={{ gap: '10px', display: 'flex', fontSize: 11 }}>
                  <img src="icon/totalViewLine.png" alt="" style={{ width: '15px', height: '15px' }} />
                  Tổng lượt xem
                </Col>
                <Col style={{ gap: '10px', display: 'flex', fontSize: 11 }}>
                  <img src="icon/totalOrdersLine.png" alt="" style={{ width: '15px', height: '15px' }} />
                  Tổng lượt mua hàng
                </Col>
              </Col>
            </Row>

            <Row style={{ padding: '0px' }}>
              <Chart
                options={chartOptions.options}
                series={chartOptions.series}
                type="line"
                style={{ width: '100%' }}
                height={420}
              />
            </Row>
          </Row>

          <Row style={{ display: 'flex', gap: '15px' }}>
            <Col style={{ flex: 1, padding: '15px', borderRadius: '16px', backgroundColor: 'white', boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)', border: '0.5px #D2D2D2' }}>
              <Row style={{ display: 'block', marginBottom: 15, fontSize: 14, fontWeight: 700 }}>
                Sản phẩm
              </Row>
              <Row style={{ display: 'block' }}>
                <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0 15px" }}>
                  <thead style={{ backgroundColor: "#ffffff" }}>
                    <tr>
                      <th style={{ width: '23px' }}></th>
                      <th style={{ textAlign: 'left', paddingLeft: '10px' }}>Sản phẩm</th> 
                      <th style={{ width: 90}}>Tổng lượt click</th>
                      <th style={{ width: 50}}>Tổng đơn</th> 
                      <th style={{ textAlign: 'right', paddingRight: '10px' }}>Tổng doanh thu</th>
                    </tr>
                  </thead>

                  <tbody>
                    {products.map((row, index) => (
                      <tr
                        key={row.id}
                        style={{
                          backgroundColor: "#F0F2F5",
                          borderBottom: "0.5px solid #F0F2F5"
                        }}
                      >
                        <td style={{ borderRadius: "8px 0 0 8px" }}>{index + 1}</td>
                        <td style={{ textAlign: 'left' }}>
                          {row.productTitle}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {row?.totalClicks}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {row?.totalOrders}
                        </td>
                        <td style={{ textAlign: 'right', borderRadius: "0 8px 8px 0" }}>
                          {row?.totalRevenue}
                        </td>
                      </tr>

                    ))}
                    {
                      products.length === 0 &&
                      <tr>
                        <td colSpan={5}>
                          <div style={{ width: '100%', textAlign: 'center' }}>
                            Không có dữ liệu phù hợp
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>

              </Row>
            </Col>
            <Col style={{ flex: 1, padding: '15px', borderRadius: '16px', backgroundColor: 'white', boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.1)', border: '0.5px #D2D2D2' }}>
              <Row style={{ display: 'block', marginBottom: 15, fontSize: 14, fontWeight: 700 }}>
                Thành viên
              </Row>
              <Row style={{ display: 'block' }}>
                <table style={{ width: "100%", borderCollapse: "separate", borderSpacing: "0 15px" }}>
                  <thead style={{ backgroundColor: "#ffffff" }}>
                    <tr>
                      <th style={{ width: '23px' }}></th>
                      <th style={{ textAlign: 'left', paddingLeft: '10px' }}>Họ và tên</th> 
                      <th style={{ width: 90}}>Tổng lượt click</th>
                      <th style={{ width: 50}}>Tổng đơn</th> 
                      <th style={{ textAlign: 'right', paddingRight: '10px' }}>Tổng doanh thu</th>
                    </tr>
                  </thead>

                  <tbody>
                    {contributors.map((row, index) => (
                      <tr
                        key={row.id}
                        style={{
                          backgroundColor: "#F0F2F5",
                          borderBottom: "0.5px solid #F0F2F5"
                        }}
                      >
                        <td style={{ borderRadius: "8px 0 0 8px" }}>{index + 1}</td>
                        <td style={{ textAlign: 'left' }}>
                          {row.fullname}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {row.totalClicks}
                        </td>
                        <td style={{ textAlign: 'center' }}>
                          {row.totalOrders}
                        </td>
                        <td style={{ textAlign: 'right', borderRadius: "0 8px 8px 0" }}>
                          {row.totalRevenue}
                        </td>
                      </tr>

                    ))}
                    {
                      contributors.length === 0 &&
                      <tr>
                        <td colSpan={5}>
                          <div style={{ width: '100%', textAlign: 'center' }}>
                            Không có dữ liệu phù hợp
                          </div>
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </Row>
            </Col>
          </Row>
        </Row>
      </div>
    </>
  );
};

export default Dashboard;